import ContactForm from "../forms/contactForm";

function Cta() {
  return (
    <>
      <section className="px-6 lg:px-24 flex flex-col lg:flex-row gap-6 lg:gap-12">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-6 w-full">
          <div className="flex flex-col items-center justify-center">
            {" "}
            <img
              src="https://magazyn.drzewus.pl/wp-content/uploads/2024/10/about-cta-1.png"
              alt="Pracownicy Drzewus przy pracy w ogrodzie"
            />
          </div>
          <div className="flex flex-col items-start justify-center">
            {" "}
            <p className="text-gray-600 text-left">
              Nasz zespół ekspertów to energiczna i pełna zapału do pracy grupa
              ludzi, którzy znają się na swojej pracy i kochają to co robią.{" "}
            </p>
          </div>
          <div className="flex flex-col items-start justify-center">
            {" "}
            <p className="text-gray-600 text-left">
              Z naszym zaangażowaniem i profesjonalnym podejściem każda
              przestrzeń zielona zyskuje, a Ty wiesz że zaufanie, którym nas
              obdarzyłeś popłaciło!{" "}
            </p>
          </div>
          <div className="flex flex-col items-center justify-center">
            {" "}
            <img
              src="https://magazyn.drzewus.pl/wp-content/uploads/2024/10/about-cta-2.png"
              alt="Prace ogrodnicze - założony ogród przez Drzewus"
            />
          </div>
        </div>
        <div className="flex flex-col items-center justify-center lg:w-2/3 w-full">
          <ContactForm />
        </div>
      </section>
    </>
  );
}

export default Cta;
